import "./styles/floatingButton.css"
import { useRef, useState } from "preact/hooks"

//Helper
const classValidation = (initial = [], logs = false) => {
    const log = (...args) => {
        if (logs) console.log(...args)
    }

    const start = (empty = false) => {
        if (empty) indexedClasses = {}
        else (typeof initial === "string" ? [initial] : initial).forEach(x => { indexedClasses[x] = true })
    }

    let indexedClasses = {}
    start()

    const add = (className) => { indexedClasses[className] = true }
    const ignoreIfClassExists = (condition, className, ignoreCase) => {
        return addIfMatches(!indexedClasses[ignoreCase] && condition, className)
    }

    const remove = (...classNames) => {
        log("remove", classNames, indexedClasses)
        classNames.forEach(cl => { indexedClasses[cl] = false })
        log("remove", indexedClasses)
    }


    const replaceIfMatches = (condition, from, to) => {
        console.log(condition, from, to)
        if (condition) remove(from)

        return addIfMatches(condition, to)
    }

    const addIfMatches = (condition, className) => { 
        log(condition, className)
        if (condition) add(className)

        const response = {
            else: (elseClass) => {
                log(condition, elseClass, indexedClasses)
                if (!condition) indexedClasses[elseClass] = true
                log(condition, elseClass, indexedClasses)
            },
            elseWithIgnore: (className, ignoreCase) => {
                console.log(className, ignoreCase)
                ignoreIfClassExists(!condition, className, ignoreCase)
            }
        }

        return {  add: (name) => addIfMatches(condition, name), ...response }
    }

    const toggle = (condition, success, fail) => {
        if (condition) {
            add(success)
            remove(fail)
        } else {
            remove(success)
            add(fail)
        }
    }

    return {
        add,
        flush: () => start(true),
        restart: () => start(),
        addIfMatches,
        ignoreIfClassExists,
        toggle,
        remove,
        replaceIfMatches,
        get: () => { 
            log(Object.keys(indexedClasses).filter(x => indexedClasses[x]), indexedClasses)
            return Object.keys(indexedClasses).filter(x => indexedClasses[x]).join(" ") 
        }
    }
}

//Static Classes
const counterClasses = classValidation("tk-floating-counter")

const seletorClasses = classValidation("tk-floating-seletor")

const pluginClasses = classValidation("tk-floating-widget")

const widgetListClasses = classValidation("tk-floating-seletor-border")

export const FloatingButtons = ({elements, openSeletor = false}) => {
    const [seletorVisible, setSeletorVisible] = useState(openSeletor)
    const [selected, setSelected] = useState(null)
    const [widgetAnimation, setWidgetAnimation] = useState(false)
    const listTop = elements.length * 60 * -1

    const [topPad, setTopPad] = useState(listTop)

    const seletor = useRef(null)
    const pluginBox = useRef(null)

    // Basic Rules
    counterClasses.addIfMatches(elements.length < 1, "hide")
    seletorClasses.toggle(seletorVisible, "show", "fadeOut")
    seletorClasses.addIfMatches(selected !== null, "showOverflow")
    widgetListClasses.toggle(selected !== null, "fadeOut", "fadeIn")
    pluginClasses.addIfMatches(selected !== null && !widgetAnimation, "fadeIn").elseWithIgnore("hide", "fadeOut")

    const showWidget = (id) => {
        seletorClasses.remove("show")
        pluginClasses.remove("hide", "fadeIn")

        setTimeout(() => {
            const widgetInfo = elements[id]
            console.log(widgetInfo)
            if (widgetInfo && widgetInfo.height) setTopPad(widgetInfo.height * -1)
        }, 100)
        
        setSelected(id)
    }

    const toggleSeletor = (ev) => {
        if (elements.length == 0 || ev.target.className !== "tk-floating-button") return;
        if (elements.length == 1) showWidget("0")
        setSeletorVisible(!seletorVisible)
    }

    const selectButton = (ev) => {
        const id = ev.path.find(data => data.getAttribute("idx")).getAttribute("idx")
        showWidget(id)
    }

    const fadeOutTime = 300

    const closeWidget = () => {

        pluginClasses.remove("hide", "fadeIn")
        pluginClasses.add("fadeOut")

        setTimeout(() => {
            setTopPad(listTop)
        }, fadeOutTime)
        
        setWidgetAnimation(true)
        setTimeout(() => {
            seletorClasses.restart()
            pluginClasses.restart()
            widgetListClasses.restart()
            pluginClasses.add("hide")
            setWidgetAnimation(false)
            setSelected(null)
            setSeletorVisible(false)
        }, 1000)
    }

    const backButton = () => {
        if (elements.length == 1) return closeWidget()
        
        pluginClasses.remove("hide", "fadeIn")
        pluginClasses.add("fadeOut")

        setTimeout(() => {
            setTopPad(listTop)
        }, fadeOutTime)

        setWidgetAnimation(true)
        setTimeout(() => {
            widgetListClasses.add("fadeIn")
            pluginClasses.remove("fadeOut")
            pluginClasses.add("hide")
            setWidgetAnimation(false)
            setSelected(null)
        }, 200)

        if (!seletor) setSeletorVisible(true)
    }

    return <div class = "tk-floating-button" onClick = {toggleSeletor}>
        <span class = {counterClasses.get()}>{elements.length}</span>
        <div style = {{top: topPad}} class = {seletorClasses.get()}>
            <div ref = {seletor} class = {widgetListClasses.get()}>
                { elements.map((element, index) => {
                    return <div class = "tk-floating-option" onClick = { selectButton } idx = {index}>
                        <div class = "tk-floating-option-icon" style = { element.bgcolor ? {background: element.bgcolor} : {} }><div>{ element.icon }</div></div>
                        <span class = "tk-floating-option-name"><div>{ element.name }</div></span>
                    </div>
                }) }
            </div>
            <div ref = {pluginBox} class = { pluginClasses.get() }>
            {selected ?
                <>
                    <div class = "tk-floating-widget-header">
                        <div>{elements[selected].name}</div>
                        <button onClick = { closeWidget }>&times;</button>
                        <button onClick = { backButton }>&gt;</button>
                    </div>
                    <div class = "tk-floating-widget-content">{elements[selected].component}</div>
                </>
            : null }
            </div>
        </div>

    </div>
}